import colors from 'assets/theme/base/colors';
import rgba from 'assets/theme/functions/rgba';

const { light } = colors;

const skeleton = {
  styleOverrides: {
    root: {
      backgroundColor: rgba(light.main, 0.4)
    }
  }
};

export default skeleton;
